import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge, validators } from 'tailwind-merge';

// Mirrors the custom keys in @firmable/tailwind-config. Without them tailwind-merge does not see
// `p-sm` or `rounded-radius-md` as padding or radius, keeps the stock shadcn class alongside, and
// the override silently loses.
const twMerge = extendTailwindMerge({
  theme: {
    spacing: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'],
    borderRadius: ['radius-none', 'radius-sm', 'radius-md', 'radius-lg', 'radius-full'],
  },
  classGroups: {
    // tailwind-merge 1.8 does not file these under their groups, so a site's z-50 would sit beside our z-auto
    // and lose on stylesheet order.
    z: [{ z: ['auto'] }],
    // tailwind-merge 1.8 only files arbitrary sizes it can read as lengths, so w-[var(--radix-popper-anchor-width)]
    // sat beside a stock w-full and lost on stylesheet order.
    w: [{ w: [validators.isArbitraryValue] }],
    'min-w': [{ 'min-w': [validators.isArbitraryValue] }],
    'max-w': [{ 'max-w': [validators.isArbitraryValue] }],
    h: [{ h: [validators.isArbitraryValue] }],
    'min-h': [{ 'min-h': [validators.isArbitraryValue] }],
    'max-h': [{ 'max-h': ['none', validators.isArbitraryValue] }],
    'font-size': [
      {
        text: [
          'feature',
          'display',
          'heading',
          'title',
          'caption',
          'body-large',
          'body-small',
          'label-large',
          'label-small',
          'display-xl',
          'display-xxl',
          'display-md',
          'display-sm',
          'l',
          'h1',
          'h2',
          'h3',
          'h4',
          'h5',
        ],
      },
    ],
    shadow: [
      {
        shadow: [
          'btn-bevel',
          'rowHighlight',
          'raised',
          'overlay',
          'overflow',
          'dropdown',
          'rightSidePanel',
          'rowHover',
          'btnFilledShadow',
          'bottom-sheet',
          'elavation2dp',
        ],
      },
    ],
    // shadcn's enter/exit plus our named animations, so a Firmable animate-* class replaces shadcn's
    // animate-in/out instead of both landing on the element (whichever CSS rule comes last would win).
    animate: [
      {
        animate: [
          'in',
          'out',
          'hide',
          'slideIn',
          'swipeOut',
          'overlayShow',
          'contentShow',
          'contentHide',
          'popoverIn',
          'popoverOut',
          'accordion-down',
          'accordion-up',
          'fadeIn',
          'tabIn',
          'tabBarIn',
          'toastSlideDown',
          'toastSlideUp',
          'sheetSlideUp',
          'backdropFadeIn',
          'popIn',
        ],
      },
    ],
  },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
